import { MenuItem, Select, TextField, Typography } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useState } from "react";

const sizeOptions = [10,15, 20, 50, 100];

export default function MyPagination({ page, total, size, onChange, onSizeChange }) {
  const pageCount = Math.ceil(total / size);
  const [p, setP] = useState("");

  function handleSizeChange(newSize) {
    if (onSizeChange) {
      onChange && onChange(null, 1);
      onSizeChange(newSize);
    } else {
      // 页面未传 onSizeChange 时，将 newSize 作为第三个参数透传给 onChange
      onChange && onChange(null, 1, newSize);
    }
  }

  return !!pageCount ? (
    <Stack direction="row" alignItems="center" justifyContent="flex-end" p={2}>
      <Typography fontSize={14} mr={1}>
        共{total}条
      </Typography>

      <Pagination page={page + 1} count={pageCount} variant="outlined" shape="rounded" onChange={onChange} />

      <Select value={size} size="small" onChange={(e) => handleSizeChange(e.target.value)}>
        {sizeOptions.map((item, idx) => (
          <MenuItem key={idx} value={item} name={item}>
            {item}条每页
          </MenuItem>
        ))}
      </Select>

      <Typography ml={1}>跳至</Typography>
      <TextField
        sx={{ width: 60, ml: 1 }}
        value={p}
        size="small"
        type="number"
        onChange={(e) => setP(e.target.value)}
        onBlur={(e) => {
          onChange(null, parseInt(e.target.value) + 1);
          setP("");
        }}
      />
      <Typography ml={1}>页</Typography>
    </Stack>
  ) : null;
}
